import {idGenerator} from '../../lib/utils/IdGenerator'
import {_getInsertReference} from './utils'

/**
 * Insert a text node in the specified position and put the cursor in that text node.
 *
 * @param {Transaction} tx - Supplied Substance transaction
 * @param {string} textType - Type of text node to create
 * @param {string} text - Text to insert
 * @param {string} inMode - Mode, 'first', 'last', 'after'
 * @param {Object} inRefNode - Reference node from where to insert new node
 */
function insertTextNode(tx, textType, text, inMode, inRefNode) {
    const content = typeof text === 'string' ? text : ''

    const {mode, refNode} = _getInsertReference(tx, inMode, inRefNode)

    const node = tx.create({
        id: idGenerator(),
        type: textType
    })

    // If inserting before or after an empty text node, the empty text node
    // gets replaced, so make sure it is not empty before inserting new node,
    // then cleanup further down.
    let clearText = false
    if (refNode.isText() && refNode.getText() === '') {
        clearText = true
        tx.update(
            [refNode.id, 'content'],
            {insert: {offset: 0, value: ' '}}
        )
    }

    tx.setSelection({
        type: 'node',
        containerId: 'body',
        nodeId: refNode.id,
        mode: mode === 'first' ? 'before' : 'after'
    })

    tx.insertBlockNode(node)

    if (text !== '') {
        tx.update(
            [node.id, 'content'],
            {insert: {offset: 0, value: content}}
        )
    }

    tx.setSelection({
        type: 'node',
        nodeId: node.id,
        containerId: 'body',
        surfaceId: 'body'
    })

    const offset = (node.getText() === '') ? 0 : node.getLength()
    tx.setSelection({
        type: 'property',
        containerId: 'body',
        path: [node.id, 'content'],
        startOffset: offset,
        endOffset: offset
    })

    // Cleanup if an empty text node temporarliy holds dummy content
    if (clearText) {
        tx.update(
            [refNode.id, 'content'],
            {delete: {start: 0, end: 1}}
        )
    }

    return node
}

export {insertTextNode}
